import { ExInput } from '@boomi/exosphere';
import styles from './SearchInput.module.css';

interface SearchInputProps {
    value: string;
    placeholder?: string;
    onSearch: (value: string) => void;
}

const SearchInput = ({ value, placeholder = 'Search', onSearch }: SearchInputProps) => (
    <div className={styles.wrapper}>
        <ExInput
            type="search"
            leadingicon="magnifying-glass"
            placeholder={placeholder}
            value={value}
            onInput={(e) => onSearch((e.target as HTMLInputElement).value)}
        />
    </div>
);

export default SearchInput;
